import React, { useContext, useEffect } from 'react';
import { Button, Table, Form } from 'react-bootstrap';
import { ChalanUpdateAndReturnContext } from '../ChalanUpdateAndReturnComponent';
import NumberSeparator from '../../../Utilities/NumberSeparator';
import { GiTargeted } from '@react-icons/all-files/gi/GiTargeted';
import Parse from '../../../Utilities/parse';

function ChalanItemsTableForReturnAndUpdate(props) {
  // getting data from context
  const { singleChalanForUpdate, setSingleChalanItemForReturn } = useContext(ChalanUpdateAndReturnContext);

  // check box un-mark lifecycle
  useEffect(() => {
    let allCheckBoxId = singleChalanForUpdate?.pur_chalan_items?.length || 0;
    for (let id = 0; id < allCheckBoxId; id++) {
      document.getElementById('purItemCheckBox' + id).checked = false;
    }
  }, [singleChalanForUpdate]);

  // item select on click
  const itemSelectOnClick = (row, index) => {
    let allCheckBoxId = singleChalanForUpdate?.pur_chalan_items?.length;
    // data set
    let selectedCheckStatus = document.getElementById('purItemCheckBox' + index).checked;
    selectedCheckStatus == true ? setSingleChalanItemForReturn(row) : setSingleChalanItemForReturn({});

    // check un-check
    for (let id = 0; id < allCheckBoxId; id++) {
      if (index != id) {
        document.getElementById('purItemCheckBox' + id).checked = false;
      }
    }
  };
  return (
    <>
      <Table
        striped
        bordered
        responsive={true}
        size="sm"
      >
        <thead>
          <tr>
            <th className="text-center">SL</th>
            <th>Product name</th>
            <th className="text-center">Category</th>
            <th className="text-center">Unit price</th>
            <th className="text-center">Qty</th>
            <th className="text-center">Total Qty</th>
            <th className="text-center">Total price</th>
          </tr>
        </thead>
        <tbody>
          {singleChalanForUpdate?.pur_chalan_items?.length != 0 &&
            singleChalanForUpdate?.pur_chalan_items?.map((item, key) => (
              <tr>
                <td className="text-center">
                  {/* check box */}
                  <Form.Check
                    id={'purItemCheckBox' + key}
                    className="d-flex align-items-center  justify-content-center"
                    type="checkbox"
                    label=""
                    onClick={(e) => {
                      itemSelectOnClick(item, key);
                    }}
                  />
                </td>
                {/* p name */}
                <td>
                  {item.cfg_product?.product_name} {item.product_style?.length != 0 && ' (' + item.product_style + ')'}
                  <br />
                  {`Sale Price: ${NumberSeparator.format(Parse.toNumber(item.reference_sale_price) * Parse.toNumber(item.stock_unit_per_pur_unit))} ${item.purchase_unit?.unit_name}`}
                  <br />
                  {` B-code : ${item.id}`}
                  {item?.cfg_store?.store_name && (
                    <>
                      <br />
                      {`Store - ${item?.cfg_store?.store_name || 'N/A'}`}
                    </>
                  )}
                </td>
                {/* category */}
                <td className="text-center">{item.cfg_product?.cfg_category?.category_name}</td>
                {/* unit price */}
                <td className="text-end">
                  {NumberSeparator.format(item.unit_pur_price * item.stock_unit_per_pur_unit)} per {item.purchase_unit?.unit_name}
                </td>
                {/* qty */}
                <td className="text-center">
                  ({NumberSeparator.format(Parse.toNumber(item.qty_in_stock_unit) / Parse.toNumber(item.stock_unit_per_pur_unit), '', 3) + ' '}+
                  {' ' + NumberSeparator.format(Parse.toNumber(item.bonus_qty_in_stock_unit) / Parse.toNumber(item.stock_unit_per_pur_unit), '', 3)}){' ' + item.purchase_unit?.unit_name}
                </td>
                {/* total qty */}
                <td className="text-center">
                  {NumberSeparator.format(Parse.toNumber(item.total_qty_in_stock_unit) / Parse.toNumber(item.stock_unit_per_pur_unit), '', 3) + ' '}
                  {item.purchase_unit?.unit_name}
                </td>
                {/* total price */}
                <td className="text-end">{NumberSeparator.format(item.total_pur_price)}</td>
              </tr>
            ))}

          {Object.keys(singleChalanForUpdate).length != 0 && (
            <tr>
              <td colSpan={5}></td>
              <td className="text-end fw-bold text-muted">Chalan Total</td>
              <td className="text-end fw-bold text-muted">{NumberSeparator.format(singleChalanForUpdate.chalan_total || 0)}</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export default ChalanItemsTableForReturnAndUpdate;
